import { render, staticRenderFns } from "./StackGrade.vue?vue&type=template&id=641f6050&scoped=true&"
import script from "./StackGrade.vue?vue&type=script&lang=js&"
export * from "./StackGrade.vue?vue&type=script&lang=js&"
import style0 from "./StackGrade.vue?vue&type=style&index=0&id=641f6050&prod&lang=css&"
import style1 from "./StackGrade.vue?vue&type=style&index=1&id=641f6050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f6050",
  null
  
)

export default component.exports